import { Button } from '@/components/common/Button';
import TinyMCEEditor from '@/components/tiny-editor';
import { useStore } from '@/hooks/useStore';
import { GeneralSettingType } from '@/types/enums';
import { toastify } from '@/utils/toastify';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface GeneralSettingProps {
    type: GeneralSettingType
}

export default observer(function GeneralSetting({ type }: GeneralSettingProps) {
    // hook
    const { t } = useTranslation();

    // state
    const [value, setValue] = useState('');

    // store
    const { generalSettingStore: { getGereralSettingByType, updateGereralSettingByType } } = useStore();

    // life cycle
    useEffect(() => {
        fetchData();
    }, [type]);

    // function
    const handleSave = async () => {
        if (value) {
            const res = await flowResult(updateGereralSettingByType({ type, value }));
            if (res) {
                toastify('success', t('messages.update_successfully'));
            }
        }
    };

    const fetchData = async () => {
        const res = await flowResult(getGereralSettingByType(type));
        if (res) {
            setValue(res);
        } else {
            setValue('');
        }
    };

    return (
        <>
            <div className='bg-white p-6 shadow rounded-md h-[90vh]'>
                <TinyMCEEditor
                    value={value}
                    onChange={setValue}
                    placeholder={t('placeholder.click_here_to_enter')}
                    height={710}
                />
                <div className='mt-7 flex justify-end'>
                    <Button className='w-40' onClick={handleSave}>{t('button.save')}</Button>
                </div>
            </div>
        </>
    );
});
